import React, { useState, useEffect } from 'react';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/manageServices/AddServiceTypeModal.css';
import Input from '../../shared/Input';
import Button from '../../shared/Button';
import { hours, minute } from '../../../data/hoursAndMinute';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import DragDrop from './DragDrop.tsx';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceDeliveryBaseURL } from '../../../Services/config/apiGateway';
import { CONFIGURESERVICE_ENDPOINT } from '../../../Services/config/apiEndPoints';
import SubmitModal from '../../shared/SuccessModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let dataFields = [];
const AddServiceTypeModal = (props) => {
  const editMode = props.editMode;
  const editValue = props.editValue;
  const [serviceDescription, setServiceDescription] = useState('');
  const [serviceTypeName, setServiceTypeName] = useState('');
  const [effectiveDateCalendar, setEffectiveDateCalendar] = useState(new Date());
  const [effectiveDateHourValue, setEffectiveDateHourValue] = useState('');
  const [effectiveDateMinuteValue, setEffectiveDateMinuteValue] = useState('');
  const [showEffectiveCalendar, setShowEffectiveCalendar] = useState(false);
  const [dropDownEffectiveHour, setDropDownEffectiveHour] = useState(false);
  const [dropDownEffectiveMinute, setDropDownEffectiveMinute] = useState(false);
  const [textLimit, setTextLimit] = useState(0);
  const [errors, setErrors] = useState({});
  const [renderEffectiveCalendar, setRenderEffectiveCalendar] = useState(false);
  const [publishHasOpen, setPublishHasOpen] = useState(false);
  const [editDate, setEditDate] = useState('');
  const [hour, setHour] = useState(hours);
  const [mm, setMM] = useState(minute);
  const container = React.createRef();
  const validateFormFields = () => {
    return (editMode ? editDate.length > 0 : renderEffectiveCalendar) &&
      effectiveDateHourValue !== '' &&
      effectiveDateMinuteValue !== '' &&
      serviceTypeName.length > 0 &&
      serviceDescription.length > 0 &&
      (editMode ? editDate.length > 0 : (dataFields.length > 0 && dataFields.map(x => x.fieldType).includes("Mandatory")))
  };
  const onPublish = () => {
    setPublishHasOpen(false)
    props.onClosePublish()
  }
  const handleSubmit = () => {
    getPublish();
  }
  const getDate = (timeStamp) => {
    let date = new Date(timeStamp).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  const getTime = (timeStamp) => {
    return new Date(timeStamp).toString().split(' ')[4].substring(0, 5)
  }
  useEffect(() => {
    console.log(editMode, editValue)
    if (editMode) {
      setServiceDescription(editValue.description)
      setServiceTypeName(editValue.serviceName)
      setTextLimit(editValue.description.length)
      setEditDate(getDate(editValue.effectiveDate))
      setEffectiveDateHourValue(getTime(editValue.effectiveDate).split(':')[0])
      setEffectiveDateMinuteValue(getTime(editValue.effectiveDate).split(':')[1])
    }
  }, [])
  const toggleEffectiveCalendar = () => {
    setShowEffectiveCalendar(!showEffectiveCalendar);
    setRenderEffectiveCalendar(true);
  }
  //formDate
  const handleEffectiveDateChanged = (e) => {
    setEffectiveDateCalendar(e);
    console.log(e.getDate() === new Date().getDate() && e.getMonth() === new Date().getMonth() && e.getFullYear() === new Date().getFullYear())
    setShowEffectiveCalendar(false);
    if (e.getDate() === new Date().getDate() && e.getMonth() === new Date().getMonth() && e.getFullYear() === new Date().getFullYear()) {
      let found = hour.filter((name) => name.hour >= e.getHours())
      setHour(found);
    }
    else {
      setHour(hours)
    }
  }
  const changeEffectiveHour = (event) => {
    let e = effectiveDateCalendar
    const found = hour.find((name) => {
      if (name.hour === event.target.innerText) {
        return name;
      }
    })
    setEffectiveDateHourValue(found.hour);
    setDropDownEffectiveHour(false);
    if (e.getDate() === new Date().getDate() && e.getMonth() === new Date().getMonth() && e.getFullYear() === new Date().getFullYear() && found.hour === new Date().getHours().toString()) {
      let foundm = mm.filter((name) => name.m >= e.getMinutes())
      setMM(foundm);
    }
    else {
      setMM(minute)
    }
  };
  const changeEffectiveMinute = (event) => {
    const found = mm.find((name) => {
      if (name.m === event.target.innerText) {
        return name;
      }
    })
    setEffectiveDateMinuteValue(found.m);
    setDropDownEffectiveMinute(false);
  };
  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setShowEffectiveCalendar(false);
      setDropDownEffectiveHour(false);
      setDropDownEffectiveMinute(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  const toggleEffectiveHourDropdown = () => {
    setDropDownEffectiveHour(!dropDownEffectiveHour)
  };
  const toggleEffectiveMinuteDropdown = () => {
    setDropDownEffectiveMinute(!dropDownEffectiveMinute)
  };
  const handleServiceDescription = (e) => {
    if (e.target.value.length <= 200) {
      setTextLimit(e.target.value.length);
      setServiceDescription(e.target.value)
    }
  }
  const handleServiceType = (e) => {
    setServiceTypeName(e.target.value);
    setErrors({ ...errors, serviceTypeName: '' });
  }
  const getPublish = () => {
    let fromTimeStamp = effectiveDateCalendar.toString().substring(4, 15) + ' ' + effectiveDateHourValue + ':' + effectiveDateMinuteValue;
    if (editMode) {
      ApiCall(
        'PUT',
        serviceDeliveryBaseURL + CONFIGURESERVICE_ENDPOINT,
        {
          "serviceId": editValue.serviceId,
          "serviceDetail": {
            "serviceName": serviceTypeName,
            "serviceId": editValue.serviceId,
            "description": serviceDescription,
            "effectiveDate": Date.parse(fromTimeStamp),
            "dataFields": editValue.dataFields,
            "feesConfiguredFlag": true,
            "serviceType": editValue.serviceId === 3 ? "Non-generic" : "Generic"
          }
        },
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-cc-trace-id': '1234',
        }
      ).then(data => {
        if (data.flag !== -1) {
          if (data.flag === 500) {
            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
          }
          else {
            console.log('I am 200!');
            setPublishHasOpen(true)
          }
        }
        else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      })
    }
    else {
      ApiCall(
        'POST',
        serviceDeliveryBaseURL + CONFIGURESERVICE_ENDPOINT,
        {
          "serviceName": serviceTypeName,
          "description": serviceDescription,
          "effectiveDate": Date.parse(fromTimeStamp),
          "dataFields": dataFields,
          "feesConfiguredFlag": true,
          "serviceType": "Generic"
        },
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-cc-trace-id': '1234',
        }
      ).then(data => {
        if (data.flag !== -1) {
          if (data.flag === 500) {
            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
          }
          else {
            console.log('I am 200!');
            setPublishHasOpen(true)
          }
        }
        else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      })
    }
  }
  const fieldsBoth = (fields) => {
    let fieldArr = [];

    fields.doing.list.map((x, i) => {
      fieldArr.push({
        fieldName: x,
        fieldType: "Mandatory",
        fieldId: fields.doing.fieldId[i],
      })
      // return;
    })
    fields.done.list.map((x, i) => {
      fieldArr.push({
        fieldName: x,
        fieldType: "Optional",
        fieldId: fields.done.fieldId[i],
      })
      // return;
    })
    dataFields = fieldArr;
  }
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let effectiveDateValue = effectiveDateCalendar.getDate() + "-" + months[effectiveDateCalendar.getMonth()] + "-" + effectiveDateCalendar.getFullYear();
  if (effectiveDateCalendar.getDate() <= 9) {
    effectiveDateValue = "0" + effectiveDateValue;
  }
  return (
    <div class="serviceTypeModalOuter" >
      <MetaDecorator title={TitleDescription.serviceTypePageTitle} description={TitleDescription.serviceTypePageDescription} />
      <div class="serviceTypeModalInner" >
        <div className='serviceTypecross'>
          <img src={cross} width="21" height="21" onClick={props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
        </div>
        <div class="serviceTypeupperdiv">
          <small class="serviceTypeModalTitle">
            Add Service Type
            </small>
        </div>
        <div className="serviceTypelowerdiv">
          <div className="serviceTypeLowerInner">
            <div className="serviceTypeLowerSubInner">
              <div className="serviceTypeLeftPart">
                <div>
                  <small className="serviceTypeFieldsTitle">Service Type</small>
                  <Input placeholder='Enter Service Name' type='text' class="serviceTypeInputBox" value={serviceTypeName} onChange={handleServiceType} />
                  <div className="serviceTypeCategoryError">{errors["serviceTypeName"]}</div>
                </div>
              </div>
              <div className="serviceTypeRightPart">
                <div class="serviceTypeEffectiveContainer">
                  <small class="serviceTypeFieldsTitle">Effective Date & Time</small>
                  <div class="serviceTypeDateRow">
                    <div class="serviceTypeDateInput">
                      <Input class="serviceTypeInputBox" placeholder="Select Date"
                        value={renderEffectiveCalendar ? effectiveDateValue : editMode ? editDate : null}
                      />
                    </div>
                    <div class="serviceTypeCalender">  {showEffectiveCalendar ? <div
                      ref={container}
                    > <Calendar onChange={handleEffectiveDateChanged} value={effectiveDateCalendar} minDate={new Date()} /></div> : null}</div>
                    <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-4" alt="" loading="lazy" onClick={toggleEffectiveCalendar}
                    />
                    <div class="servicetypehourMinuteDiv">
                      <input class="serviceTypeInputBox" placeholder="HH" value={effectiveDateHourValue}></input>
                    </div>
                    <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleEffectiveHourDropdown} />
                    <div>
                      {dropDownEffectiveHour && (
                        <div class="border" id="serviceTypeHourDropdown"
                          ref={container}
                        >
                          {
                            hour.map((datah, indexh) => {
                              return (
                                <table class="serviceTypeHourHover">
                                  <tr onClick={(index1) => changeEffectiveHour(index1)}>
                                    <small class="hourMinuteText">{datah.hour}</small>
                                  </tr>
                                </table>
                              )
                            }
                            )}
                        </div>
                      )}</div>
                    <div class="servicetypehourMinuteDiv">
                      <input class="serviceTypeInputBox" placeholder="MM" value={effectiveDateMinuteValue}></input>
                    </div>
                    <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleEffectiveMinuteDropdown} />
                    <div>
                      {dropDownEffectiveMinute && (
                        <div class="border" id="serviceTypeMinuteDropdown"
                          ref={container}
                        >
                          {
                            mm.map((datam, indexh) => {
                              return (
                                <table class="serviceTypeHourHover">
                                  <tr onClick={(index1) => changeEffectiveMinute(index1)}>
                                    <small class="hourMinuteText">{datam.m}</small>
                                  </tr>
                                </table>
                              )
                            }
                            )}
                        </div>
                      )}</div>
                  </div>
                </div>
              </div>
              <div className="serciceDescriptionPartDiv">
                <div>
                  <small className="serviceTypeFieldsTitle">Service Description</small>
                  <Input placeholder='Enter Service Description' type='text' class="serviceTypeInputBox" value={serviceDescription} onChange={handleServiceDescription} />
                  <small class="serviceTypeTextLimit">{textLimit}/200</small>
                </div>
              </div>
              {/* DRAG ADN DROP CODE */}
              <DragDrop setFields={fieldsBoth} isEdit={editMode} editValue={editMode ? editValue.dataFields : null} />
              <div className="serviceTypeModalFooter">
                <div className="serviceTypeNoteDiv">
                  <div>
                    <small className="serviceTypeNoteText">Note:</small>
                  </div>
                  <small className="serviceTypeNoteContent">Fields added here will be visible to Requester while raising the request for the added service type.</small>
                </div>
                <div>
                  <div class="serviceTypePublishContainer"
                  >
                    <Button class="serviceTypePublishButton" disabled={!validateFormFields()} onClick={handleSubmit}>Publish</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SubmitModal onClick={onPublish} hasOpen={publishHasOpen} >
        <div className="successSectionTextContainer">
          <h5 className="successHeading">New service type is created successfully.</h5>
          <p className="successSectionText">Please update the transaction fees for this service under Transaction Fees tile.</p>
        </div>
      </SubmitModal>
    </div>
  );
}
export default AddServiceTypeModal;